var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.48,240.88s-4.11,17.32-4.11,27.57,7.07,23.48,18.69,19.15S362.51,271,362.51,263s-.45-18.91-.45-18.91-5.7,4.56-14.59,1.59S334.48,240.88,334.48,240.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339,379.91c-.23-3.42-.46-14.36,6.61-32.36s12.53-44.91,13.9-67,2.51-36.47,2.51-36.47c0-4.11,1.59-6.61,13.67-4.79s39.43,5.7,39.21,9.35-16,54.7-17.78,68.15-1.37,18.91,5.47,15.49S419,323.16,419,323.16v10.25s-24.16,31-31.23,35.79-6.84,3.87-8.66-1.6-1.82-24.38-1.82-24.38c-7.69,21.08-7.28,33.14-6.43,38.28H339.15C339.12,381,339.08,380.52,339,379.91Zm48.53-76.44,9-33.5M259.29,381.5h41.49c1.36-5.77,7.62-32.13,12.27-46.49,5.24-16.18,12.08-36.24,13.45-48.32s7.07-44.22,7.07-44.22c.91-6.15,0-5.47,0-5.47s-43.77.68-47,.91-1.82,22.11-1.82,53.34C284.79,319.94,262.86,373.05,259.29,381.5Zm33.48-87.06,7.29-9.57",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.77,331.59s11.63-4.79,18.46-10.48,18.92-22.57,21-22.34,14.36,9.12,20.52,11.17,10.71,2.05,10.48,3.42-2.73,2.73-7.52,2.73-17.78-6.84-17.78-6.84,7.07,9.12,5.93,10.26a65.2,65.2,0,0,1-14.59,8.66c-5.47,2.05-9.12,3.88-10.26,3.65s-.91-2.51-.22-3.19l2.05-2.05S334,330,331.51,330H329l-19.6,16.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.72,237.46s-7.53-.69-9.35-.69-4.56,1.37-5,7.52S246,365.55,246,368.51s4.53,4,18.53.46c11.81-3,46.89-14.81,46.89-14.81l3.1-24.89L278,336.61l17.78-52.2",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.66,325.17s-5.67,2.45-10,4.13-1.84,3.22-.15,3.22,8.27-2,10.72-3.52S434.41,324.71,431.66,325.17Z",
    style: {
      fill: "#4AA848",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.79,319.22s-7.7,3.33-13.53,5.61-2.49,4.37-.2,4.37,11.23-2.7,14.56-4.78S438.53,318.59,434.79,319.22Z",
    style: {
      fill: "#4AA848",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.56,313.66s-8.44,3.64-14.82,6.15-2.73,4.79-.23,4.79,12.31-3,16-5.25S438.66,313,434.56,313.66Z",
    style: {
      fill: "#4AA848",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.22,308.57s-8.43,3.65-14.81,6.15-2.74,4.79-.23,4.79,12.31-3,15.95-5.24S439.32,307.89,435.22,308.57Z",
    style: {
      fill: "#4AA848",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.29,182.75s-16.41,10.49-19.83,14.59-1.82,12.77-1.59,15.5.45,21,2.05,23.93,6.49,14.72,22.41,14c11.47-.53,17.25-9.87,19.53-15.8a50.17,50.17,0,0,0,2.73-12.76s6.63-1.15,6.63-6.62-1.48-11.85-4.58-11.16c-1.57.35-3.64,3.87-3.64,3.87a87.66,87.66,0,0,1-16-14.13C349.75,185.72,349.29,182.75,349.29,182.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-10--inject-34"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 333.34,
    cy: 211.47,
    r: 9.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-11--inject-34"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 358.87,
    cy: 211.47,
    r: 9.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.2,381.07V370.36c0-8.42-6.88-16.07-13.77-23.72s5.36-48.19,6.12-81.85-15.3-43.61-29.83-33.66S380.3,199,376.47,175.28s-26-65-62-59.66S286.2,160,268.61,166.11s-38.25-17.6-74.21-3.06S160.74,273.2,143.91,291.56s-40.54-19.12-60.43,0c-18.68,18-17.79,81.82-17.61,89.51Z",
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.2,381.07V370.36c0-8.42-6.88-16.07-13.77-23.72s5.36-48.19,6.12-81.85-15.3-43.61-29.83-33.66S380.3,199,376.47,175.28s-26-65-62-59.66S286.2,160,268.61,166.11s-38.25-17.6-74.21-3.06S160.74,273.2,143.91,291.56s-40.54-19.12-60.43,0c-18.68,18-17.79,81.82-17.61,89.51Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.21,165.89s-26.44-2.51-30.08,10.25,9.11,23.48,13,25.53a31.52,31.52,0,0,1-1.6,20.74C313.74,233.58,308,250,283,272.79s-42.17,32.13-46.27,57.66,8.2,35.56,41.93,35.79S367.3,326.58,381,279.17s9.8-67,9.12-84.11S379.61,162,362.28,160.19,337.21,165.89,337.21,165.89Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.34,185.71s-27.67-8.51-29.38-1.28,17.46,10.22,17.46,6.39S321.2,187,321.2,187",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.73,164.85s-22.56-.85-23.84,7.24,31.08,33.2,43.85,36.61",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.07,164.85s-7.66,4.68-4.68,10.22,19.15,12.77,27.24,12.77",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.47,238.36a236.45,236.45,0,0,1,27.55,0c14.67.9,19.76,6.59,19.76,6.59s-22.16,90.13-24.26,106.9-2.39,29.65-2.39,29.65H293s13.47-57.5,18.86-85.34S327.47,238.36,327.47,238.36Z",
    style: {
      fill: "#4AA848",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.48,240.88s-4.11,17.32-4.11,27.57,7.07,23.48,18.69,19.15S362.51,271,362.51,263s-.45-18.91-.45-18.91-5.7,4.56-14.59,1.59S334.48,240.88,334.48,240.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-34)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.47,258.2c-.12-7-.41-14.13-.41-14.13s-5.7,4.56-14.59,1.59-13-4.78-13-4.78-1.89,8-3.11,16.3c2.58,4.19,7.25,7.76,15.78,7.28C354,264.07,358.9,261.64,362.47,258.2Z",
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.47,258.2c-.12-7-.41-14.13-.41-14.13s-5.7,4.56-14.59,1.59-13-4.78-13-4.78-1.89,8-3.11,16.3c2.58,4.19,7.25,7.76,15.78,7.28C354,264.07,358.9,261.64,362.47,258.2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M334.48,240.88s-4.11,17.32-4.11,27.57,7.07,23.48,18.69,19.15S362.51,271,362.51,263s-.45-18.91-.45-18.91-5.7,4.56-14.59,1.59S334.48,240.88,334.48,240.88Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.92,247.71s-5.47,7.3-7.07,14.59.91,11.63.91,11.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,379.91c-.23-3.42-.46-14.36,6.61-32.36s12.53-44.91,13.9-67,2.51-36.47,2.51-36.47c0-4.11,1.59-6.61,13.67-4.79s39.43,5.7,39.21,9.35-16,54.7-17.78,68.15-1.37,18.91,5.47,15.49S419,323.16,419,323.16v10.25s-24.16,31-31.23,35.79-6.84,3.87-8.66-1.6-1.82-24.38-1.82-24.38c-7.69,21.08-7.28,33.14-6.43,38.28H339.15C339.12,381,339.08,380.52,339,379.91Zm48.53-76.44,9-33.5M259.29,381.5h41.49c1.36-5.77,7.62-32.13,12.27-46.49,5.24-16.18,12.08-36.24,13.45-48.32s7.07-44.22,7.07-44.22c.91-6.15,0-5.47,0-5.47s-43.77.68-47,.91-1.82,22.11-1.82,53.34C284.79,319.94,262.86,373.05,259.29,381.5Zm33.48-87.06,7.29-9.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-34)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.16,316.78c.35-2.6,1.22-6.59,2.39-11.37l-8.35-1.57s-28.57,50.9-42.86,61.62c-3.2,2.4-6.31,4.58-9.09,6.62a45.61,45.61,0,0,0-.21,7.83c0,.61.08,1.12.11,1.59H370.9c-.85-5.14-1.26-17.2,6.43-38.28,0,0,0,18.91,1.82,24.38s1.6,6.39,8.66,1.6S419,333.41,419,333.41V323.16s-9.57,5.7-16.41,9.11S395.33,330.22,397.16,316.78Z",
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.17,306.07l-6.56,13.12c-6.55,26.71-18.74,56.2-21.32,62.31h9.88Z",
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.16,316.78c.35-2.6,1.22-6.59,2.39-11.37l-8.35-1.57s-28.57,50.9-42.86,61.62c-3.2,2.4-6.31,4.58-9.09,6.62a45.61,45.61,0,0,0-.21,7.83c0,.61.08,1.12.11,1.59H370.9c-.85-5.14-1.26-17.2,6.43-38.28,0,0,0,18.91,1.82,24.38s1.6,6.39,8.66,1.6S419,333.41,419,333.41V323.16s-9.57,5.7-16.41,9.11S395.33,330.22,397.16,316.78Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.17,306.07l-6.56,13.12c-6.55,26.71-18.74,56.2-21.32,62.31h9.88Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M339,379.91c-.23-3.42-.46-14.36,6.61-32.36s12.53-44.91,13.9-67,2.51-36.47,2.51-36.47c0-4.11,1.59-6.61,13.67-4.79s39.43,5.7,39.21,9.35-16,54.7-17.78,68.15-1.37,18.91,5.47,15.49S419,323.16,419,323.16v10.25s-24.16,31-31.23,35.79-6.84,3.87-8.66-1.6-1.82-24.38-1.82-24.38c-7.69,21.08-7.28,33.14-6.43,38.28H339.15C339.12,381,339.08,380.52,339,379.91Zm48.53-76.44,9-33.5M259.29,381.5h41.49c1.36-5.77,7.62-32.13,12.27-46.49,5.24-16.18,12.08-36.24,13.45-48.32s7.07-44.22,7.07-44.22c.91-6.15,0-5.47,0-5.47s-43.77.68-47,.91-1.82,22.11-1.82,53.34C284.79,319.94,262.86,373.05,259.29,381.5Zm33.48-87.06,7.29-9.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "331.29 236.77 313.28 269.14 320.57 279.17 312.14 285.09 307.13 350.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "368.71 241.12 374.24 274.37 366.65 280.18 375.58 288.21 353.25 341.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.77,331.59s11.63-4.79,18.46-10.48,18.92-22.57,21-22.34,14.36,9.12,20.52,11.17,10.71,2.05,10.48,3.42-2.73,2.73-7.52,2.73-17.78-6.84-17.78-6.84,7.07,9.12,5.93,10.26a65.2,65.2,0,0,1-14.59,8.66c-5.47,2.05-9.12,3.88-10.26,3.65s-.91-2.51-.22-3.19l2.05-2.05S334,330,331.51,330H329l-19.6,16.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-34)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.2,315.21l-.2,0c-10.75-.74-25.56-9.63-25.56-9.63l2.46,3.69s13,6.84,17.78,6.84A14.55,14.55,0,0,0,379.2,315.21Z",
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.66,317.78c-1.85,1.49-4.81-1.85-4.81-1.85s.74,7.41-1.48,7.78-5.19-1.85-5.19-1.85,0,4.81-2.22,4.81-5.55-7-5.55-7,.8,3.52-1.49,5.92-6.66,1.85-6.66,1.85L310.85,340l-1,1.16-.49,5.46L329,330h2.5c2.51,0,7.3-3.42,7.3-3.42l-2.05,2.05c-.69.68-.92,3,.22,3.19s4.79-1.6,10.26-3.65a65.2,65.2,0,0,0,14.59-8.66c1.14-1.14-5.93-10.26-5.93-10.26S357.51,316.3,355.66,317.78Z",
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.2,315.21l-.2,0c-10.75-.74-25.56-9.63-25.56-9.63l2.46,3.69s13,6.84,17.78,6.84A14.55,14.55,0,0,0,379.2,315.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.66,317.78c-1.85,1.49-4.81-1.85-4.81-1.85s.74,7.41-1.48,7.78-5.19-1.85-5.19-1.85,0,4.81-2.22,4.81-5.55-7-5.55-7,.8,3.52-1.49,5.92-6.66,1.85-6.66,1.85L310.85,340l-1,1.16-.49,5.46L329,330h2.5c2.51,0,7.3-3.42,7.3-3.42l-2.05,2.05c-.69.68-.92,3,.22,3.19s4.79-1.6,10.26-3.65a65.2,65.2,0,0,0,14.59-8.66c1.14-1.14-5.93-10.26-5.93-10.26S357.51,316.3,355.66,317.78Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 338.81,
    y1: 326.58,
    x2: 337.21,
    y2: 323.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.14,318.83s4.56,8.43,4.1,9.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.29,312.67s7.07,10,5.93,11.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M310.77,331.59s11.63-4.79,18.46-10.48,18.92-22.57,21-22.34,14.36,9.12,20.52,11.17,10.71,2.05,10.48,3.42-2.73,2.73-7.52,2.73-17.78-6.84-17.78-6.84,7.07,9.12,5.93,10.26a65.2,65.2,0,0,1-14.59,8.66c-5.47,2.05-9.12,3.88-10.26,3.65s-.91-2.51-.22-3.19l2.05-2.05S334,330,331.51,330H329l-19.6,16.63Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.72,237.46s-7.53-.69-9.35-.69-4.56,1.37-5,7.52S246,365.55,246,368.51s4.53,4,18.53.46c11.81-3,46.89-14.81,46.89-14.81l3.1-24.89L278,336.61l17.78-52.2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-34)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.49,345.85c-2.58.69-43.44,11.66-51.22,14.25-8,2.68,8.93-10.72,3.13-10.27s-12.51,8.48-12.51,8.48l15.54-76.26C258.49,318,246,366.6,246,368.51c0,3,4.53,4,18.53.46,11.81-3,46.89-14.81,46.89-14.81Z",
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.49,345.85c-2.58.69-43.44,11.66-51.22,14.25-8,2.68,8.93-10.72,3.13-10.27s-12.51,8.48-12.51,8.48l15.54-76.26C258.49,318,246,366.6,246,368.51c0,3,4.53,4,18.53.46,11.81-3,46.89-14.81,46.89-14.81Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M290.72,237.46s-7.53-.69-9.35-.69-4.56,1.37-5,7.52S246,365.55,246,368.51s4.53,4,18.53.46c11.81-3,46.89-14.81,46.89-14.81l3.1-24.89L278,336.61l17.78-52.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.22 300.52 290.17 326.05 306.63 326.71 308.18 301.89 292.22 300.52",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.38 294.1 298.16 304.13 302.49 304.36 302.71 294.1 298.38 294.1",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.55,287.79l-29.3,64.1a2.59,2.59,0,0,0,2.33,3.67l47.48.4a2.58,2.58,0,0,0,2.35-1.45L441,291.43a2.59,2.59,0,0,0-2.26-3.72L390,286.28A2.61,2.61,0,0,0,387.55,287.79Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.24,
    y1: 333.16,
    x2: 365.9,
    y2: 338.29,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.21,287.48l-7.25-.22a2.6,2.6,0,0,0-2.43,1.52L370,329.25",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.32,
    y1: 287.66,
    x2: 400.48,
    y2: 287.54,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.66,325.17s-5.67,2.45-10,4.13-1.84,3.22-.15,3.22,8.27-2,10.72-3.52S434.41,324.71,431.66,325.17Z",
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-34)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.66,325.17s-5.67,2.45-10,4.13-1.84,3.22-.15,3.22,8.27-2,10.72-3.52S434.41,324.71,431.66,325.17Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M431.66,325.17s-5.67,2.45-10,4.13-1.84,3.22-.15,3.22,8.27-2,10.72-3.52S434.41,324.71,431.66,325.17Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.79,319.22s-7.7,3.33-13.53,5.61-2.49,4.37-.2,4.37,11.23-2.7,14.56-4.78S438.53,318.59,434.79,319.22Z",
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-34)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.79,319.22s-7.7,3.33-13.53,5.61-2.49,4.37-.2,4.37,11.23-2.7,14.56-4.78S438.53,318.59,434.79,319.22Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M434.79,319.22s-7.7,3.33-13.53,5.61-2.49,4.37-.2,4.37,11.23-2.7,14.56-4.78S438.53,318.59,434.79,319.22Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.56,313.66s-8.44,3.64-14.82,6.15-2.73,4.79-.23,4.79,12.31-3,16-5.25S438.66,313,434.56,313.66Z",
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-34)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.56,313.66s-8.44,3.64-14.82,6.15-2.73,4.79-.23,4.79,12.31-3,16-5.25S438.66,313,434.56,313.66Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M434.56,313.66s-8.44,3.64-14.82,6.15-2.73,4.79-.23,4.79,12.31-3,16-5.25S438.66,313,434.56,313.66Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.22,308.57s-8.43,3.65-14.81,6.15-2.74,4.79-.23,4.79,12.31-3,15.95-5.24S439.32,307.89,435.22,308.57Z",
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-34)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.22,308.57s-8.43,3.65-14.81,6.15-2.74,4.79-.23,4.79,12.31-3,15.95-5.24S439.32,307.89,435.22,308.57Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M435.22,308.57s-8.43,3.65-14.81,6.15-2.74,4.79-.23,4.79,12.31-3,15.95-5.24S439.32,307.89,435.22,308.57Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.29,182.75s-16.41,10.49-19.83,14.59-1.82,12.77-1.59,15.5.45,21,2.05,23.93,6.49,14.72,22.41,14c11.47-.53,17.25-9.87,19.53-15.8a50.17,50.17,0,0,0,2.73-12.76s6.63-1.15,6.63-6.62-1.48-11.85-4.58-11.16c-1.57.35-3.64,3.87-3.64,3.87a87.66,87.66,0,0,1-16-14.13C349.75,185.72,349.29,182.75,349.29,182.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-34)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.26,192.24s15,19.86,24.74,16a87.66,87.66,0,0,1-16-14.13c-7.29-8.43-7.75-11.4-7.75-11.4s-16.41,10.49-19.83,14.59a8.63,8.63,0,0,0-1.61,3.38Z",
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,212.22a18,18,0,0,1-1.29,5.2c-1.86,4.08-6.67,3.34-6.67,3.34s-3,15.55-7,20.36-15.18,8.89-26.29,3.34-9.63-19.26-9.63-19.26,6.67,0,9.26-6.3-.74-9.26-7.41-8.88a6.67,6.67,0,0,0-4.21,1.71c.05.43.09.81.12,1.11.23,2.74.45,21,2.05,23.93s6.49,14.72,22.41,14c11.47-.53,17.25-9.87,19.53-15.8a50.17,50.17,0,0,0,2.73-12.76s6.63-1.15,6.63-6.62A31.49,31.49,0,0,0,381,212.22Z",
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,212.22a18,18,0,0,1-1.29,5.2c-1.86,4.08-6.67,3.34-6.67,3.34s-3,15.55-7,20.36-15.18,8.89-26.29,3.34-9.63-19.26-9.63-19.26,6.67,0,9.26-6.3-.74-9.26-7.41-8.88a6.67,6.67,0,0,0-4.21,1.71c.05.43.09.81.12,1.11.23,2.74.45,21,2.05,23.93s6.49,14.72,22.41,14c11.47-.53,17.25-9.87,19.53-15.8a50.17,50.17,0,0,0,2.73-12.76s6.63-1.15,6.63-6.62A31.49,31.49,0,0,0,381,212.22Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.75,
    cy: 214.37,
    r: 9.14,
    transform: "translate(-54.87 154.56) rotate(-22.63)",
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.75,
    cy: 214.37,
    r: 9.14,
    transform: "translate(-54.87 154.56) rotate(-22.63)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.26,192.24s15,19.86,24.74,16a87.66,87.66,0,0,1-16-14.13c-7.29-8.43-7.75-11.4-7.75-11.4s-16.41,10.49-19.83,14.59a8.63,8.63,0,0,0-1.61,3.38Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M349.29,182.75s-16.41,10.49-19.83,14.59-1.82,12.77-1.59,15.5.45,21,2.05,23.93,6.49,14.72,22.41,14c11.47-.53,17.25-9.87,19.53-15.8a50.17,50.17,0,0,0,2.73-12.76s6.63-1.15,6.63-6.62-1.48-11.85-4.58-11.16c-1.57.35-3.64,3.87-3.64,3.87a87.66,87.66,0,0,1-16-14.13C349.75,185.72,349.29,182.75,349.29,182.75Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.34,
    cy: 211.47,
    r: 9.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-10--inject-34)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.61,216.73a9.35,9.35,0,0,0,16.64-8.07c-.78,1.71-1.71,3-2.72,3.08-3.16.27-3.75-.41-6.19-.27C331.76,211.57,328.05,214.59,325.61,216.73Z",
    style: {
      fill: "#4AA848"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 333.34,
    cy: 211.47,
    r: 9.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.87,
    cy: 211.47,
    r: 9.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-11--inject-34)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.87,220.82a9.35,9.35,0,0,0,9.34-9.35,9.18,9.18,0,0,0-.48-2.93c-3.24,5.79-7.19,2.77-11.15,2.37-2.38-.24-4.62,2.38-6.1,4.67A9.34,9.34,0,0,0,358.87,220.82Z",
    style: {
      fill: "#4AA848"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 358.87,
    cy: 211.47,
    r: 9.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.68,207.83s3.88-3.42,7.3,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.92,199.62s3.42-4.79,8.89-3.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.89,195.52s5.47-2.28,10.71,3.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.05,211.25s.68,5.47-.68,8-4.33,3.88-3.19,5.7,5,2.74,5,2.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.28,232.9s5.7,1.37,9.57-2.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.88,
    y1: 381.5,
    x2: 61.73,
    y2: 381.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 408.3,
    y1: 381.5,
    x2: 146.8,
    y2: 381.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.01,
    y1: 381.5,
    x2: 415.73,
    y2: 381.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-34"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.41,
    y: 177.86,
    width: 181.67,
    height: 113.15,
    style: {
      fill: "#fff",
      opacity: 0.71
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.45,171.1V297.76H292V171.1ZM289.07,291H107.41V177.86H289.07Z",
    style: {
      fill: "#4AA848",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.67,181.44h121.4a3.37,3.37,0,0,1,3.37,3.37v3.28a3.38,3.38,0,0,1-3.38,3.38H114.67a3.37,3.37,0,0,1-3.37-3.37v-3.28A3.37,3.37,0,0,1,114.67,181.44Z",
    style: {
      fill: "#4AA848",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.38,
    y1: 202.82,
    x2: 139.75,
    y2: 202.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.38,
    y1: 208.76,
    x2: 139.75,
    y2: 208.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.38,
    y1: 214.7,
    x2: 139.75,
    y2: 214.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.38,
    y1: 221.02,
    x2: 139.75,
    y2: 221.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.88,
    y1: 202.82,
    x2: 171.25,
    y2: 202.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.88,
    y1: 208.76,
    x2: 171.25,
    y2: 208.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.88,
    y1: 214.7,
    x2: 171.25,
    y2: 214.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.88,
    y1: 221.02,
    x2: 171.25,
    y2: 221.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.38,
    y1: 202.82,
    x2: 202.75,
    y2: 202.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.38,
    y1: 208.76,
    x2: 202.75,
    y2: 208.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.38,
    y1: 214.7,
    x2: 202.75,
    y2: 214.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.38,
    y1: 221.02,
    x2: 202.75,
    y2: 221.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 207.88,
    y1: 202.82,
    x2: 234.25,
    y2: 202.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 207.88,
    y1: 208.76,
    x2: 234.25,
    y2: 208.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 207.88,
    y1: 214.7,
    x2: 234.25,
    y2: 214.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 207.88,
    y1: 221.02,
    x2: 234.25,
    y2: 221.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "129.26 263.25 151.65 240.86 168.13 255.65 182.07 242.97 202.78 258.6 225.17 234.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.65,
    cy: 240.86,
    r: 2.96,
    style: {
      fill: "#4AA848",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182.07,
    cy: 242.97,
    r: 2.96,
    style: {
      fill: "#4AA848",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.78,
    cy: 258.6,
    r: 2.96,
    style: {
      fill: "#4AA848",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.75,
    cy: 234.94,
    r: 2.96,
    style: {
      fill: "#4AA848",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.26,
    cy: 263.25,
    r: 2.96,
    style: {
      fill: "#4AA848",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.13,
    cy: 254.8,
    r: 2.96,
    style: {
      fill: "#4AA848",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.59,288.48h0a1.7,1.7,0,0,1-1.7-1.7V183a1.7,1.7,0,0,1,1.7-1.7h0a1.71,1.71,0,0,1,1.71,1.7V286.78A1.71,1.71,0,0,1,247.59,288.48Z",
    style: {
      fill: "#4AA848",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.36,
    y1: 202.13,
    x2: 285.38,
    y2: 202.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.78,
    y1: 202.13,
    x2: 259.42,
    y2: 202.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.06,
    y1: 207.15,
    x2: 285.38,
    y2: 207.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.7,
    y1: 207.15,
    x2: 279.34,
    y2: 207.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.78,
    y1: 207.15,
    x2: 268.17,
    y2: 207.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.47,
    y1: 212.17,
    x2: 285.38,
    y2: 212.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.78,
    y1: 212.17,
    x2: 264.85,
    y2: 212.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 278.13,
    y1: 217.18,
    x2: 285.38,
    y2: 217.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.02,
    y1: 217.18,
    x2: 275.11,
    y2: 217.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.78,
    y1: 217.18,
    x2: 256.7,
    y2: 217.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.36,
    y1: 221.57,
    x2: 285.38,
    y2: 221.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.78,
    y1: 221.57,
    x2: 259.42,
    y2: 221.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.06,
    y1: 226.59,
    x2: 285.38,
    y2: 226.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.7,
    y1: 226.59,
    x2: 279.34,
    y2: 226.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.78,
    y1: 226.59,
    x2: 268.17,
    y2: 226.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.47,
    y1: 231.6,
    x2: 285.38,
    y2: 231.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.78,
    y1: 231.6,
    x2: 264.85,
    y2: 231.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 278.13,
    y1: 236.62,
    x2: 285.38,
    y2: 236.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.02,
    y1: 236.62,
    x2: 275.11,
    y2: 236.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.78,
    y1: 236.62,
    x2: 256.7,
    y2: 236.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.36,
    y1: 241.01,
    x2: 285.38,
    y2: 241.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.78,
    y1: 241.01,
    x2: 259.42,
    y2: 241.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.06,
    y1: 246.02,
    x2: 285.38,
    y2: 246.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.7,
    y1: 246.02,
    x2: 279.34,
    y2: 246.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.78,
    y1: 246.02,
    x2: 268.17,
    y2: 246.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.47,
    y1: 251.04,
    x2: 285.38,
    y2: 251.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.78,
    y1: 251.04,
    x2: 264.85,
    y2: 251.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 278.13,
    y1: 256.06,
    x2: 285.38,
    y2: 256.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.02,
    y1: 256.06,
    x2: 275.11,
    y2: 256.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.78,
    y1: 256.06,
    x2: 256.7,
    y2: 256.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.36,
    y1: 260.44,
    x2: 285.38,
    y2: 260.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.78,
    y1: 260.44,
    x2: 259.42,
    y2: 260.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.06,
    y1: 265.46,
    x2: 285.38,
    y2: 265.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.7,
    y1: 265.46,
    x2: 279.34,
    y2: 265.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.78,
    y1: 265.46,
    x2: 268.17,
    y2: 265.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.47,
    y1: 270.48,
    x2: 285.38,
    y2: 270.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.78,
    y1: 270.48,
    x2: 264.85,
    y2: 270.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 278.13,
    y1: 275.49,
    x2: 285.38,
    y2: 275.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.02,
    y1: 275.49,
    x2: 275.11,
    y2: 275.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.78,
    y1: 275.49,
    x2: 256.7,
    y2: 275.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.57,
    y: 277.97,
    width: 4.5,
    height: 10,
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.57,
    y: 282.43,
    width: 4.5,
    height: 5.54,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.57,
    y: 285.01,
    width: 4.5,
    height: 2.96,
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.57,
    y: 280.89,
    width: 4.5,
    height: 7.08,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.57,
    y: 283.46,
    width: 4.5,
    height: 4.51,
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.57,
    y: 280.54,
    width: 4.5,
    height: 7.43,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.57,
    y: 286.72,
    width: 4.5,
    height: 1.25,
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.57,
    y: 277.97,
    width: 4.5,
    height: 10,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.57,
    y: 284.32,
    width: 4.5,
    height: 3.65,
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.57,
    y: 286.55,
    width: 4.5,
    height: 1.42,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.57,
    y: 284.66,
    width: 4.5,
    height: 3.31,
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.57,
    y: 277.97,
    width: 4.5,
    height: 10,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.57,
    y: 280.03,
    width: 4.5,
    height: 7.94,
    style: {
      fill: "#4AA848"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.57,
    y: 281.4,
    width: 4.5,
    height: 6.57,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "256 195.24 256 142.87 266.03 142.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.83,
    y1: 142.5,
    x2: 292.4,
    y2: 142.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.83,
    y1: 148.44,
    x2: 292.4,
    y2: 148.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.83,
    y1: 154.38,
    x2: 292.4,
    y2: 154.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.66,
    y1: 357.14,
    x2: 136.34,
    y2: 357.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.66,
    y1: 362.71,
    x2: 136.34,
    y2: 362.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.66,
    y1: 368.28,
    x2: 136.34,
    y2: 368.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.66,
    y1: 373.85,
    x2: 136.34,
    y2: 373.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.45,
    cy: 336.02,
    r: 30.83,
    transform: "translate(-73.38 50.31) rotate(-13.46)",
    style: {
      fill: "#4AA848",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.45,
    cy: 336.02,
    r: 23.03,
    transform: "translate(-73.15 50.11) rotate(-13.42)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.45,
    cy: 336.02,
    r: 14.55,
    transform: "translate(-201.39 371.83) rotate(-67.71)",
    style: {
      fill: "#4AA848",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.67,
    cy: 336.02,
    r: 15.23,
    transform: "translate(-200.5 187.99) rotate(-45)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.67,
    cy: 336.02,
    r: 8.52,
    transform: "translate(-200.5 187.99) rotate(-45)",
    style: {
      fill: "#4AA848",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.81,
    cy: 336.02,
    r: 8.91,
    transform: "translate(-52.98 20.37) rotate(-9.3)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.81,336a5,5,0,1,0-5,5A5,5,0,0,0,103.81,336Z",
    style: {
      fill: "#4AA848",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.45,
    y1: 336.02,
    x2: 79.87,
    y2: 336.02,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.03,
    y: 122.59,
    width: 61.29,
    height: 53.86,
    style: {
      fill: "#fff",
      opacity: 0.71
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.03,
    y: 122.59,
    width: 61.29,
    height: 53.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.03,
    y: 122.59,
    width: 61.29,
    height: 9.16,
    style: {
      fill: "#4AA848",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.86,
    cy: 151.57,
    r: 12.63,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.94 143.24 217.74 151.78 202.94 160.33 202.94 143.24",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDs);
export default __webpack_public_path__ + "static/media/ds.b9426b54edcc444cb327042dd01400bf.svg";
export { ForwardRef as ReactComponent };